import { forwardRef } from 'react';
import { cn } from '@divlab/divanui';

import * as PickPairStore from '@Stores/PickPair';
import useTranslation from '@Queries/useTranslation';
import ConstructorImage from '../ConstructorImage';
import Sidebar from './elements/Sidebar';
import styles from './Set.module.css';

import type { HTMLAttributes } from 'react';
import type { IConstructor } from '@Pages/PagePickAndPair/typings';

interface SetProps extends HTMLAttributes<HTMLDivElement> {
  constructor: IConstructor;
}

const Set = forwardRef<HTMLDivElement, SetProps>((props, ref) => {
  const { className, constructor, ...restProps } = props;
  const { set, product } = constructor;
  const { t } = useTranslation();
  const { productImages } = PickPairStore.useProductInfo();
  const title = t('constructor.title');
  const description = t('constructor.description');

  return (
    <div className={cn(styles.wrapper, className)} ref={ref} {...restProps}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      <div className={styles.container}>
        {productImages.length > 0 && <ConstructorImage images={productImages} />}

        <Sidebar set={set} product={product} />
      </div>
    </div>
  );
});

Set.displayName = 'Set';

export default Set;
